import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import '../styles/mission.css';

const JoshMission = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/josh-mission.md')
      .then(response => response.text())
      .then(text => {
        setContent(text);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading mission statement:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="mission-content">
        <div className="container">
          <p>Loading...</p>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="page-header">
        <div className="container">
          <h2>Josh's Mission Statement</h2>
        </div>
      </section>

      <section className="mission-content">
        <div className="container">
          <div className="markdown-content">
            <ReactMarkdown>{content}</ReactMarkdown>
          </div>
        </div>
      </section>
    </>
  );
};

export default JoshMission;